import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {HttpModule} from '@angular/http';
import {BrowserModule} from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {LocationStrategy, HashLocationStrategy} from '@angular/common';
import {AppRoutes} from './app.routes';
import 'rxjs/add/operator/toPromise';
import { DatePipe } from '@angular/common';
import {HttpClientModule} from '@angular/common/http';

import {AccordionModule} from 'primeng/primeng';
import {AutoCompleteModule} from 'primeng/primeng';
import {BreadcrumbModule} from 'primeng/primeng';
import {ButtonModule} from 'primeng/primeng';
import {CalendarModule} from 'primeng/primeng';
import {CarouselModule} from 'primeng/primeng';
import {ColorPickerModule} from 'primeng/primeng';
import {ChartModule} from 'primeng/primeng';
import {CheckboxModule} from 'primeng/primeng';
import {ChipsModule} from 'primeng/primeng';
import {CodeHighlighterModule} from 'primeng/primeng';
import {ConfirmDialogModule} from 'primeng/primeng';
import {SharedModule} from 'primeng/primeng';
import {ContextMenuModule} from 'primeng/primeng';
import {DataGridModule} from 'primeng/primeng';
import {DataListModule} from 'primeng/primeng';
import {DataScrollerModule} from 'primeng/primeng';
import {DataTableModule} from 'primeng/primeng';
import {DialogModule} from 'primeng/primeng';
import {DragDropModule} from 'primeng/primeng';
import {DropdownModule} from 'primeng/primeng';
import {EditorModule} from 'primeng/primeng';
import {FieldsetModule} from 'primeng/primeng';
import {FileUploadModule} from 'primeng/primeng';
import {GalleriaModule} from 'primeng/primeng';
import {GMapModule} from 'primeng/primeng';
import {GrowlModule} from 'primeng/primeng';
import {InputMaskModule} from 'primeng/primeng';
import {InputSwitchModule} from 'primeng/primeng';
import {InputTextModule} from 'primeng/primeng';
import {InputTextareaModule} from 'primeng/primeng';
import {LightboxModule} from 'primeng/primeng';
import {ListboxModule} from 'primeng/primeng';
import {MegaMenuModule} from 'primeng/primeng';
import {MenuModule} from 'primeng/primeng';
import {MenubarModule} from 'primeng/primeng';
import {MessagesModule} from 'primeng/primeng';
import {MultiSelectModule} from 'primeng/primeng';
import {OrderListModule} from 'primeng/primeng';
import {OrganizationChartModule} from 'primeng/primeng';
import {OverlayPanelModule} from 'primeng/primeng';
import {PaginatorModule} from 'primeng/primeng';
import {PanelModule} from 'primeng/primeng';
import {PanelMenuModule} from 'primeng/primeng';
import {PasswordModule} from 'primeng/primeng';
import {PickListModule} from 'primeng/primeng';
import {ProgressBarModule} from 'primeng/primeng';
import {RadioButtonModule} from 'primeng/primeng';
import {RatingModule} from 'primeng/primeng';
import {ScheduleModule} from 'primeng/primeng';
import {ScrollPanelModule} from 'primeng/primeng';
import {SelectButtonModule} from 'primeng/primeng';
import {SlideMenuModule} from 'primeng/primeng';
import {SliderModule} from 'primeng/primeng';
import {SpinnerModule} from 'primeng/primeng';
import {SplitButtonModule} from 'primeng/primeng';
import {StepsModule} from 'primeng/primeng';
import {TableModule} from 'primeng/table';
import {TabMenuModule} from 'primeng/primeng';
import {TabViewModule} from 'primeng/primeng';
import {TerminalModule} from 'primeng/primeng';
import {TieredMenuModule} from 'primeng/primeng';
import {ToggleButtonModule} from 'primeng/primeng';
import {ToolbarModule} from 'primeng/primeng';
import {TooltipModule} from 'primeng/primeng';
import {TreeModule} from 'primeng/primeng';
import {TreeTableModule} from 'primeng/primeng';
import {BlockUIModule} from 'primeng/primeng';
import {KeyFilterModule} from 'primeng/primeng';
import {CardModule} from 'primeng/primeng';
import {ProgressSpinnerModule} from 'primeng/primeng';
import {ConfirmationService} from 'primeng/primeng';
import {CaptchaModule} from 'primeng/primeng';
import {MessageModule} from 'primeng/message';

import {AppComponent} from './app.component';
import {AppMenuComponent, AppSubMenuComponent} from './app.menu.component';
import {AppTopBarComponent} from './app.topbar.component';
import {AppFooterComponent} from './app.footer.component';
import {AppProfileComponent} from './app.profile.component';
import {DashboardDemoComponent} from './demo/view/dashboarddemo.component';
import {SampleDemoComponent} from './demo/view/sampledemo.component';
import {FormsDemoComponent} from './demo/view/formsdemo.component';
import {DataDemoComponent} from './demo/view/datademo.component';
import {PanelsDemoComponent} from './demo/view/panelsdemo.component';
import {OverlaysDemoComponent} from './demo/view/overlaysdemo.component';
import {MenusDemoComponent} from './demo/view/menusdemo.component';
import {MessagesDemoComponent} from './demo/view/messagesdemo.component';
import {MiscDemoComponent} from './demo/view/miscdemo.component';
import {EmptyDemoComponent} from './demo/view/emptydemo.component';
import {ChartsDemoComponent} from './demo/view/chartsdemo.component';
import {FileDemoComponent} from './demo/view/filedemo.component';
import {UtilsDemoComponent} from './demo/view/utilsdemo.component';
import {DocumentationComponent} from './demo/view/documentation.component';

import {CarService} from './demo/service/carservice';
import {CountryService} from './demo/service/countryservice';
import {EventService} from './demo/service/eventservice';
import {NodeService} from './demo/service/nodeservice';
import { LoginComponent } from './login/login.component';
import { HomeComponent } from './home/home.component';
import { UserService } from './services/user.service';
import { UserComponent } from './user/user.component';
import { MainService } from './services/main.service';
import { ProfileComponent } from './profile/profile.component';
import { CompanyComponent } from './company/company.component';
import { ProfileService } from './services/profile.service';
import { CompanyService } from './services//company.service';
import { AccountComponent } from './account/account.component';
import { DeviceComponent } from './device/device.component';
import { ProtocolComponent } from './protocol/protocol.component';
import { ProtocolService } from './services/protocol.service';
import { ProtocolCommandService } from './services/protocol-command.service';
import { CommandService } from './services/command.service';
import { DeviceTypeComponent } from './device-type/device-type.component';
import { DeviceTypeService } from './services/device-type.service';
import { DeviceService } from './services/device.service';
import { UserDeviceComponent } from './user-device/user-device.component';
import { UserDeviceService } from './services/user-device.service';
import { PositionService } from './services/position.service';
import { WebsocketService } from './services/websocket.service';
import { SharingService } from './services/sharing.service';
import {} from '@types/googlemaps';
import { PositionHistoryComponent } from './position-history/position-history.component';
import { GeofenceComponent } from './geofence/geofence.component';
import { GeofenceService } from './services/geofence.service';
import { PositionReportComponent } from './position-report/position-report.component';
import { StoppedTimeReportComponent } from './stopped-time-report/stopped-time-report.component';
import { DistanceTraveledReportComponent } from './distance-traveled-report/distance-traveled-report.component';
import { FuelConsumptionReportComponent } from './fuel-consumption-report/fuel-consumption-report.component';
import { TravelReportComponent } from './travel-report/travel-report.component';
import { ExcessSpeedReportComponent } from './excess-speed-report/excess-speed-report.component';
import { LeisureReportComponent } from './leisure-report/leisure-report.component';
import { AlarmReportComponent } from './alarm-report/alarm-report.component';
import { DrivingOutsideHoursReportComponent } from './driving-outside-hours-report/driving-outside-hours-report.component';
import { StatusReportComponent } from './status-report/status-report.component';
import { SchedulingReportService } from './services/scheduling-report.service';
import { SchedulingReportComponent } from './scheduling-report/scheduling-report.component';
import { BinnacleComponent } from './binnacle/binnacle.component';
import { BinnacleService } from './services/binnacle.service';
import { AlarmTypeComponent } from './alarm-type/alarm-type.component';
import { AlarmTypeService } from './services/alarm-type.service';
import { AlarmComponent } from './alarm/alarm.component';
import { AlarmService } from './services/alarm.service';
import { RecaptchaService } from './services/recaptcha.service';
import { InterestPointComponent } from './interest-point/interest-point.component';
import { InterestPointService } from './services/interest-point.service';
import { AddressService } from './services/address.service';
import { MaintenanceTypeService } from './services/maintenance-type.service';
import { MaintenanceService } from './services/maintenance.service';
import { HierarchyComponent } from './hierarchy/hierarchy.component';
import { DriverComponent } from './driver/driver.component';
import { DriverService } from './services/driver.service';
import { TravelDriverReportComponent } from './travel-driver-report/travel-driver-report.component';
import { AlarmDriverReportComponent } from './alarm-driver-report/alarm-driver-report.component';
import { DeviceWithoutReportingComponent } from './device-without-reporting/device-without-reporting.component';
import { MonitoringComponent } from './monitoring/monitoring.component';
import { MaintenanceTypeComponent } from './maintenance-type/maintenance-type.component';
import { MaintenanceComponent } from './maintenance/maintenance.component';
import { AddressComponent } from './address/address.component';
import { ViolationReportComponent } from './violation-report/violation-report.component';
import { SummaryInfractionReportComponent } from './summary-infraction-report/summary-infraction-report.component';
import { SummaryDistanceTraveledReportComponent } from './summary-distance-traveled-report/summary-distance-traveled-report.component';
import { SummaryInfranctionsByDayReportComponent } from './summary-infranctions-by-day-report/summary-infranctions-by-day-report.component';
import { CommandReportComponent } from './command-report/command-report.component';
import {GoogleMapsLoaderService} from './services/google-maps-loader.service';
import { GeofenceReportComponent } from './geofence-report/geofence-report.component';

@NgModule({
    imports: [
        BrowserModule,
        FormsModule,
        AppRoutes,
        HttpModule,
        HttpClientModule,
        BrowserAnimationsModule,
        AccordionModule,
        AutoCompleteModule,
        BreadcrumbModule,
        ButtonModule,
        CalendarModule,
        CarouselModule,
        ColorPickerModule,
        ChartModule,
        CheckboxModule,
        ChipsModule,
        CodeHighlighterModule,
        ConfirmDialogModule,
        SharedModule,
        ContextMenuModule,
        DataGridModule,
        DataListModule,
        DataScrollerModule,
        DataTableModule,
        DialogModule,
        DragDropModule,
        DropdownModule,
        EditorModule,
        FieldsetModule,
        FileUploadModule,
        GalleriaModule,
        GMapModule,
        GrowlModule,
        InputMaskModule,
        InputSwitchModule,
        InputTextModule,
        InputTextareaModule,
        LightboxModule,
        ListboxModule,
        MegaMenuModule,
        MenuModule,
        MenubarModule,
        MessagesModule,
        MessageModule,
        MultiSelectModule,
        OrderListModule,
        OrganizationChartModule,
        OverlayPanelModule,
        PaginatorModule,
        PanelModule,
        PanelMenuModule,
        PasswordModule,
        PickListModule,
        ProgressBarModule,
        RadioButtonModule,
        RatingModule,
        ScheduleModule,
        ScrollPanelModule,
        SelectButtonModule,
        SlideMenuModule,
        SliderModule,
        SpinnerModule,
        SplitButtonModule,
        StepsModule,
        TableModule,
        TabMenuModule,
        TabViewModule,
        TerminalModule,
        TieredMenuModule,
        ToggleButtonModule,
        ToolbarModule,
        TooltipModule,
        TreeModule,
        TreeTableModule,
        BlockUIModule,
        KeyFilterModule,
        CardModule,
        ProgressSpinnerModule,
        CaptchaModule
    ],
    declarations: [
        AppComponent,
        AppMenuComponent,
        AppSubMenuComponent,
        AppTopBarComponent,
        AppFooterComponent,
        AppProfileComponent,
        DashboardDemoComponent,
        SampleDemoComponent,
        FormsDemoComponent,
        DataDemoComponent,
        PanelsDemoComponent,
        OverlaysDemoComponent,
        MenusDemoComponent,
        MessagesDemoComponent,
        MessagesDemoComponent,
        MiscDemoComponent,
        ChartsDemoComponent,
        EmptyDemoComponent,
        FileDemoComponent,
        UtilsDemoComponent,
        DocumentationComponent,
        LoginComponent,
        HomeComponent,
        UserComponent,
        ProfileComponent,
        CompanyComponent,
        AccountComponent,
        DeviceComponent,
        ProtocolComponent,
        DeviceTypeComponent,
        UserDeviceComponent,
        PositionHistoryComponent,
        GeofenceComponent,
        PositionReportComponent,
        StoppedTimeReportComponent,
        DistanceTraveledReportComponent,
        FuelConsumptionReportComponent,
        TravelReportComponent,
        ExcessSpeedReportComponent,
        LeisureReportComponent,
        AlarmReportComponent,
        DrivingOutsideHoursReportComponent,
        StatusReportComponent,
        SchedulingReportComponent,
        BinnacleComponent,
        AlarmTypeComponent,
        AlarmComponent,
        InterestPointComponent,
        AddressComponent,
        HierarchyComponent,
        DriverComponent,
        TravelDriverReportComponent,
        AlarmDriverReportComponent,
        DeviceWithoutReportingComponent,
        MonitoringComponent,
        MaintenanceTypeComponent,
        MaintenanceComponent,
        ViolationReportComponent,
        SummaryInfractionReportComponent,
        SummaryDistanceTraveledReportComponent,
        SummaryInfranctionsByDayReportComponent,
        CommandReportComponent,
        GeofenceReportComponent
    ],
    providers: [
        {provide: LocationStrategy, useClass: HashLocationStrategy},WebsocketService,
        ConfirmationService,CarService, CountryService, DatePipe,EventService, NodeService, UserService, MainService, ProfileService, CompanyService,
        ProtocolService, ProtocolCommandService,CommandService,DeviceTypeService, DeviceService, UserDeviceService, PositionService, GeofenceService,
        SchedulingReportService, BinnacleService, AlarmTypeService, AlarmService, RecaptchaService, InterestPointService, AddressService, DriverService,
        MaintenanceTypeService, MaintenanceService, SharingService, GoogleMapsLoaderService
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts